import { Modal, Checkbox } from "@sunrun/experience-ui-components";
import { ReactNode, useState } from "react";
import styled from "@emotion/styled/macro";

type ConfirmModalProps = {
  title: string;
  children: ReactNode;
  onClose: () => void;
  onCloseX?: () => void;
  onConfirm: () => void;
  confirmLabel: string;
  cancelLabel?: string;
  loading?: boolean;
  modalType?: "info" | "error" | "warning";
  additionalConfirmation?: string;
  hideIcon?: boolean;
};

const ConfirmModal = ({
  title,
  children,
  onClose,
  onCloseX,
  onConfirm,
  confirmLabel,
  cancelLabel,
  loading = false,
  modalType = "info",
  additionalConfirmation,
  hideIcon,
}: ConfirmModalProps) => {
  const [checkboxChecked, setCheckboxChecked] = useState(false);

  return (
    <Modal
      testId="checkout-confirm-modal"
      hideIcon={hideIcon}
      title={title}
      type={modalType}
      primaryButton={{
        text: loading ? "Loading" : confirmLabel,
        onClick: onConfirm,
        disabled: loading || (!!additionalConfirmation && !checkboxChecked),
      }}
      secondaryButton={{
        text: cancelLabel || "Cancel",
        onClick: onClose,
        disabled: loading,
      }}
      onClose={onCloseX ? onCloseX : onClose}
    >
      {children}
      {additionalConfirmation && (
        <Checkbox
          onClick={() => setCheckboxChecked(!checkboxChecked)}
          label={additionalConfirmation}
        />
      )}
      {loading && <LoadingOverlay data-testid="loading-overlay" />}
    </Modal>
  );
};

const LoadingOverlay = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  cursor: progress;
`;

export { ConfirmModal };
export type { ConfirmModalProps };
